import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import { selectors, actions } from '../sagas/sign_up/account_information';
import { actions as company_actions } from '../sagas/account';
import { selectors as company_selectors } from '../sagas/account';
import { TextInput } from '../shared/TextInput'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import KmDatePicker from '../shared/KmDatePicker'
import moment from 'moment'

class AccountForm extends Component {
  constructor(props) {
    super(props)
    this.updateCompanyInfoForm = this.props.actions.accountActions.updateCompanyInfoForm.bind(this)
  }

  handleCustomSubmit = () => {
    this.updateCompanyInfoForm(this.props.user_form)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <div>
        <form
          onSubmit={handleSubmit(this.handleCustomSubmit)}>
          <div>
            <div style={{ marginLeft: 0, marginRight: 0}} className={'row'}>
              <div className={'column'}>
                <TextInput
                  placeholderText={'Business Name'}
                  inputName={'name'}
                  label={'Business Name'}
                />
                <TextInput
                  placeholderText={'First Name'}
                  inputName={'firstName'}
                  label={'First Name'}
                />
                <TextInput
                  placeholderText={'Last Name'}
                  inputName={'lastName'}
                  label={'Last Name'}
                />
                <KmDatePicker
                  label={'Birthdate'}
                  change={ this.props.actions.company_actions.setBirthdate }
                  date={ moment(this.props.birthdate) || moment().subtract(13, 'years') }
                  maxDate={ moment().subtract(13, 'years') }
                  showYearDropdown
                  wrapperClass={'km-date-picker account-bd'}
                  questionMark={ true }
                  dataTip={ "We store all information in a secured database and don't share or sell any of your personal information. <br> This is required to verify your account with our payment processor" }
                />
                <TextInput
                  placeholderText={'Last 4 of SSN'}
                  inputName={'last4'}
                  label={'Last 4 Digits of SSN'}
                  questionMark={ true }
                  dataTip={ "We store all information in a secured database and don't share or sell any of your personal information. <br> This is required to verify your account with our payment processor" }
                />
              </div>
              <div className={'column'}>
                <TextInput
                  placeholderText={'Street Address'}
                  inputName={'streetAddress'}
                  label={'Street Address'}
                />
                <TextInput
                  placeholderText={'Apt/Suite'}
                  inputName={'address2'}
                  label={'Address Line 2'}
                />
                <TextInput
                  placeholderText={'City'}
                  inputName={'city'}
                  label={'City'}
                />
                <TextInput
                  placeholderText={'State/Province'}
                  inputName={'state'}
                  label={'State'}
                />
                <TextInput
                  placeholderText={'Postal Code'}
                  inputName={'postalCode'}
                  label={'Postal Code'}
                />
              </div>
              <div className={'column'}>
                <TextInput
                  placeholderText={'Employer Identification Number'}
                  inputName={'employerIdentificationNumber'}
                  label={'Employer Identification Number (EIN)'}
                  questionMark={ true }
                  dataTip={ "We store all information in a secured database and don't share or sell any of your personal information. <br> This is required to verify your account with our payment processor" }
                />
                <TextInput
                  placeholderText={'Email'}
                  inputName={'companyEmail'}
                  label={'Company Email'}
                />
                <TextInput
                  placeholderText={'( )'}
                  inputName={'phone'}
                  label={'Phone'}
                />
                <TextInput
                  placeholderText={'Website'}
                  inputName={'website'}
                  label={'Website'}
                />
                <TextInput
                  placeholderText={'Reservations Link'}
                  inputName={'kegmeistersLink'}
                  label={'Reservations Link'}
                  disabled={ true }
                  questionMark={ true }
                  dataTip={ "Link to this page from your website to allow consumers to reserve a keg" }
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'column'}>
                { this.props.create &&
                <div className={'create-account-button'}>
                  <input
                    value="Create"
                    type="submit"
                    id='continue-button' />
                </div>
                }
                { this.props.create === undefined &&
                <div className={'update-account-button'}>
                  <input
                    value="Save"
                    type="submit"
                    id='continue-button' />
                </div>
                }
              </div>
            </div>
          </div>
        </form>
        <ReactTooltip multiline={ true }/>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  initialValues: company_selectors.account_info(store),
  birthdate: company_selectors.account_info(store)['birthdate']
});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      company_actions: bindActionCreators(company_actions, dispatch),
      accountActions: bindActionCreators(actions, dispatch)
    }
  };
}

export default (connect(mapStateToProps, mapDispatchToProps)
  (reduxForm({ form: 'account_form'})(AccountForm)));



// WEBPACK FOOTER //
// ./src/Account/form.jsx